import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "@/lib/content";
import { ArrowRight } from "lucide-react";

const PROGRAMS = [
  { key: "garbha", to: "/garbhsanskar" },
  { key: "yoga", to: "/yoga" },
];

/**
 * Two large photo cards — Garbhsanskar and the 21-Day Yoga course — each opening
 * its full programme page. Copy and imagery come from Admin → Site Content.
 */
export const ProgramCards = () => {
  const { c, img } = useContent();
  return (
    <section className="border-t border-border" data-testid="home-programs">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-28">
        <div className="mb-14">
          <div className="overline mb-3">{c("home.programs.overline")}</div>
          <h2 className="font-display text-4xl lg:text-5xl max-w-2xl" data-testid="home-programs-title">
            {c("home.programs.title")}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
          {PROGRAMS.map(({ key, to }) => (
            <Link
              key={key}
              to={to}
              className="group relative rounded-[2rem] overflow-hidden border border-border min-h-[24rem] flex items-end"
              data-testid={`program-card-${key}`}
            >
              <img
                src={img(`home.programs.${key}_image`)}
                alt={c(`home.programs.${key}_title`)}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[hsl(145_42%_12%_/_0.92)] via-[hsl(145_42%_12%_/_0.45)] to-transparent" />
              <div className="relative p-8 lg:p-10 text-primary-foreground">
                <h3 className="font-display text-3xl lg:text-4xl mb-3">{c(`home.programs.${key}_title`)}</h3>
                <p className="text-sm opacity-85 max-w-sm leading-relaxed mb-6">{c(`home.programs.${key}_desc`)}</p>
                <span className="btn-action inline-flex items-center gap-2 h-11 px-6 text-sm font-medium">
                  {c(`home.programs.${key}_cta`)} <ArrowRight size={15} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramCards;
